import { useTranslation } from "react-i18next";
import asAppstore from "~/images/as_appStore.png";
import asGoogleplay from "~/images/as_googlePlay.png";
import AsQrcode from "~/images/as_qrcode.png";
import { typography } from "~/styles/typographies";
import { gtag } from "~/utils/gtag";
import { BottomSheet } from "./BottomSheet";
import { Button } from "./Buttons/Button";
import styles from "./GuideBottomSheet.module.css";

export interface GuideBottomSheetProps {
  onClose: () => void;
}

export function GuideBottomSheet({ onClose }: GuideBottomSheetProps) {
  const { t } = useTranslation("guidance");

  return (
    <BottomSheet
      description={t("getBonus")}
      largeTitle={t("nextEpisodeLarge")}
      smallTitle={t("nextEpisodeSmall")}
      onClose={onClose}
    >
      <div className={styles.desktop}>
        <div
          className={typography({ fontSize: "body3", fontWeight: "medium" })}
        >
          {t("qrCodeDescription")}
          <a
            className={styles.qrCodeContainer}
            href="https://shortcha.sng.link/A0kry/5880/mm3d"
            rel="noreferrer"
            target="_blank"
          >
            <div className={styles.qrCode}>
              <img alt="qrCode" src={AsQrcode} />
            </div>
          </a>
        </div>
        <div
          className={typography({ fontSize: "body3", fontWeight: "medium" })}
        >
          {t("downloadApp")}
          <div className={styles.stores}>
            <div
              className={typography({
                fontSize: "caption2",
                fontWeight: "bold",
              })}
            >
              {t("appstore")}
              <a
                className={styles.storeLink}
                href="https://apps.apple.com/kr/app/id6575347654"
                rel="noreferrer"
                target="_blank"
                onClick={() => {
                  gtag.sendEvent({
                    eventName: "w_click",
                    wEventId: 13,
                    wTarget: "appstore",
                  });
                }}
              >
                <img alt="app store" src={asAppstore} />
              </a>
            </div>
            <div
              className={typography({
                fontSize: "caption2",
                fontWeight: "bold",
              })}
            >
              {t("googleplay")}
              <a
                className={styles.storeLink}
                href="https://play.google.com/store/apps/details?id=com.frograms.atom"
                rel="noreferrer"
                target="_blank"
                onClick={() => {
                  gtag.sendEvent({
                    eventName: "w_click",
                    wEventId: 13,
                    wTarget: "googleplay",
                  });
                }}
              >
                <img alt="google play" src={asGoogleplay} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.mobile}>
        <a
          className={styles.qrCodeContainer}
          href="https://shortcha.sng.link/A0kry/5880/mm3d"
          rel="noreferrer"
          target="_blank"
        >
          <Button
            size="large"
            text={t("openApp")}
            type="primary"
            variant="filled"
            full
          />
        </a>
      </div>
    </BottomSheet>
  );
}
